import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from "redux-form";
import {renderTextField} from "./inputs/TextFeaild";
import {renderSelectField} from "./inputs/SelectField";
import {renderDateField} from "./inputs/DateFeaild";

export class TaskForm extends React.Component {

    render() {

        const {handleSubmit, errors, users} = this.props;

        return (
            <form onSubmit={handleSubmit}>

                <Field name="name"
                       label="課題名"
                       err={errors.name}
                       component={renderTextField}
                       type="text"/>

                <Field name="detail"
                       multiline
                       rows={1}
                       rowsMax={4}
                       label="詳細"
                       err={errors.detail}
                       component={renderTextField}
                       type="text"/>

                <Field name="pic_id"
                       label="担当者"
                       err={errors.pic}
                       data={users}
                       component={renderSelectField}
                       type="text"/>

                <Field name="priority"
                       label="優先度"
                       err={errors.priority}
                       data={[{id: 1, name: '高優先'}, {id: 2, name: '通常'}, {id: 3, name: '低優先'}]}
                       component={renderSelectField}
                       type="text"/>

                <Field name="limited_at"
                       label="期日"
                       err={errors.limited_at}
                       component={renderDateField}
                       type="date"
                />
            </form>
        )
    }
}

TaskForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired,
};

TaskForm = reduxForm({
    form: 'task'
})(TaskForm);


// WEBPACK FOOTER //
// ./src/forms/task.js